var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import OkCancelModal from '@/shared/components/OkCancelModal';
import ToastrService from '@/shared/services/ToastrService';
import { useChangeCommunicationEmail } from '@/shared/hooks/profile/useChangeCommunicationEmail';
import adminpulse from '@/shared/utils/adminpulse';
import messages from '../profileMessages';
var ChangeCommunicationEmailModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, currentEmail = _a.currentEmail;
    var intl = useIntl();
    var changeCommunicationEmail = useChangeCommunicationEmail().changeCommunicationEmail;
    var _b = useState(''), email = _b[0], setEmail = _b[1];
    var _c = useState(false), dirty = _c[0], setDirty = _c[1];
    var trimmedEmail = email.trim();
    var isValid = adminpulse.isValidEmail(trimmedEmail);
    var isSameAsCurrent = !!currentEmail && trimmedEmail.toLowerCase() === currentEmail.toLowerCase();
    var formValid = isValid && !isSameAsCurrent;
    var handleClose = function () {
        setEmail('');
        setDirty(false);
        onClose();
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, changeCommunicationEmail({ newEmail: trimmedEmail })];
                case 1:
                    _b.sent();
                    ToastrService.success(intl.formatMessage(messages.CommunicationEmailChangeSent));
                    handleClose();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(OkCancelModal, __assign({ title: intl.formatMessage(messages.ChangeCommunicationEmail), show: show, onSave: handleSave, onClose: handleClose, disabled: !formValid, okLabel: intl.formatMessage(messages.SendEmail) }, { children: _jsxs("div", __assign({ className: "form-horizontal" }, { children: [_jsx("div", __assign({ role: "alert", className: "alert alert-info" }, { children: _jsx("div", { children: intl.formatMessage(messages.ChangeCommunicationEmailInfo) }) })), _jsxs("div", __assign({ className: classNames('form-group', {
                        'has-error': dirty && !formValid,
                    }) }, { children: [_jsx("label", __assign({ className: "control-label col-md-4" }, { children: intl.formatMessage(messages.NewCommunicationEmail) })), _jsxs("div", __assign({ className: "col-md-8" }, { children: [_jsx("input", { type: "email", className: "form-control", value: email, onChange: function (e) {
                                        setEmail(e.target.value);
                                        setDirty(true);
                                    } }), dirty && !email && (_jsx("ul", __assign({ className: "help-block" }, { children: _jsx("li", { children: intl.formatMessage(messages.FieldRequired) }) }))), dirty && email && !isValid && (_jsx("ul", __assign({ className: "help-block" }, { children: _jsx("li", { children: intl.formatMessage(messages.InvalidEmailAddress) }) })))] }))] }))] })) })));
};
export default ChangeCommunicationEmailModal;
